<template>
  <div class="dashboard-components">
    <el-row :gutter="10">
      <el-col :span="10">
        <div class="dashboard-p2-content">
          <div class="dashboard-title">
            <h2>{{ querydata.levelValue }}品类份额占比
            <el-select v-model="type" placeholder="请选择" size="mini" @change="initData()" popper-class="singlecodetopselect">
              <el-option
                class="barchart-miniselector"
                v-for="item in typeoptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            </h2>
          </div>
          <div id="treemap" class="dashboard-p2-tree-item"></div>
        </div>
      </el-col>
      <el-col :span="7">
        <div class="dashboard-p2-content">
          <div class="dashboard-title">
            <h2>{{ querydata.levelValue }}品类增量 ({{ unit }}) </h2>
          </div>
          <div id="bar1" class="dashboard-p2-bar-item"></div>
        </div>
      </el-col>
      <el-col :span="7">
        <div class="dashboard-p2-content">
          <div class="dashboard-title">
            <h2>{{ querydata.levelValue }}品类增长率</h2>
          </div>
          <div id="bar2" class="dashboard-p2-bar-item"></div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
	props: {
		chartdata: {
      type: Object
    },
		querydata: {
      type: Object
    },
	},
  data(){
    return{
			type: 0,
      unit: '',
			typeoptions: [{
				label: this.$t('SingleCodeAnalysis.t08'),
				value: 0
			},{
				label: this.$t('SingleCodeAnalysis.t07'),
				value: 1
			},{
				label: this.$t('SingleCodeAnalysis.t06'),
				value: 2
			},{
				label: '当月',
				value: 3
			}],
      tooltip1: '进口数量',
      tooltip2: '同比增长',
      tooltip3: '同比增加',
      color: ['rgb(0,148,115)', 'rgb(51,102,153)', 'rgb(240,192,90)', 'rgb(190,69,116)', 'rgb(112,48,160)', 'rgb(150,79,76)']
    }
  },

  created() {
    this.$nextTick(() => {
			this.initData()
    })
  },

  watch: {
    'chartdata'() {
      this.$nextTick(() => {
				this.initData()
      })
    },
  },

  methods: {
    /**
     * 初始化数据
     */
    initData: function(){
      let that = this
      that.$emit('show-title', {type: that.type, unit: that.chartdata.MAT.unit})
      let _q = that.querydata
			if(_q.flow == 'import'){
        if(_q.index == 'volume'){
          that.tooltip1 = that.$t('charttxt.t1') + that.$t('charttxt.t4')
        }
        if(_q.index == 'value'){
          that.tooltip1 = that.$t('charttxt.t1') + that.$t('charttxt.t3')
        }
			}
			if(_q.flow == 'export'){
        if(_q.index == 'volume'){
          that.tooltip1 = that.$t('charttxt.t2') + that.$t('charttxt.t4')
        }
        if(_q.index == 'value'){
          that.tooltip1 = that.$t('charttxt.t2') + that.$t('charttxt.t3')
        }
			}

      let treemapdata = []
      let bar1 = {x: [], y: []}
      let bar2 = {x: [], y: []}
      let _data = that.chartdata
      that.unit = _data.MAT.unit
      if(that.type == 0){
        _data.MATList.reverse().forEach(item => {
          bar1.x.push(item.item)
          bar1.y.push(item.value.toFixed(0))
          bar2.x.push(item.item)
          bar2.y.push(item.growth.toFixed(1))
          treemapdata.push({
            name: item.item,
            value: item.proportion.toFixed(1),
            total: item.value.toFixed(0),
            unit: item.unit,
            growth: item.growth.toFixed(0),
            growth_yoy: item.growth_yoy
          })
        })
      }
      if(that.type == 1){
        _data.YTDList.reverse().forEach(item => {
          bar1.x.push(item.item)
          bar1.y.push(item.value.toFixed(0))
          bar2.x.push(item.item)
          bar2.y.push(item.growth.toFixed(1))
          treemapdata.push({
            name: item.item,
            value: item.proportion,
            total: item.value.toFixed(0),
            unit: item.unit,
            growth: item.growth.toFixed(0),
            growth_yoy: item.growth_yoy
          })
        })
      }
      if(that.type == 2){
        _data.lastThreeMonthList.reverse().forEach(item => {
          bar1.x.push(item.item)
          bar1.y.push(item.value.toFixed(0))
          bar2.x.push(item.item)
          bar2.y.push(item.growth.toFixed(1))
          treemapdata.push({
            name: item.item,
            value: item.proportion,
            total: item.value.toFixed(0),
            unit: item.unit,
            growth: item.growth.toFixed(0),
            growth_yoy: item.growth_yoy
          })
        })
      }
      if(that.type == 3){
        _data.currentList.reverse().forEach(item => {
          bar1.x.push(item.item)
          bar1.y.push(item.value.toFixed(0))
          bar2.x.push(item.item)
          bar2.y.push(item.growth.toFixed(1))
          treemapdata.push({
            name: item.item,
            value: item.proportion,
            total: item.value.toFixed(0),
            unit: item.unit,
            growth: item.growth.toFixed(0),
            growth_yoy: item.growth_yoy
          })
        })
      }
      that.initTreemap('treemap', treemapdata)
      that.initBar('bar1', bar1, false)
      that.initBar('bar2', bar2, true)
    },

    /**
     * 柱状图
     */
    initBar: function(id, data, ispercent){
      let that = this
      let myBarChart = this.echarts.init(document.getElementById(id))
      myBarChart.clear()
      myBarChart.setOption({
        legend: {},
        grid: {
          left: 60,
          top: 0,
          bottom: 30,
          right: 30
        },
        xAxis: {
          type: 'value',
          position: 'left',
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: '#ffffff'
            }
          },
					axisLabel: {
						formatter: function (value) {
              let _v = ''
              if(ispercent == true){
                _v = value + '%'
              }else{
                _v = value
              }
              return _v
            }
					}
        },
        yAxis: {
          type: 'category',
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: '#ffffff'
            }
          },
          // axisLabel: {
          //   width: 20,
          // },
          data: data.x
        },
        series: [
          {
            type: 'bar',
            barWidth: '50%',
            label: {
              show: true,
              formatter: ispercent ? '{c}%' : '{c}',
            },
            itemStyle: {
              color: function(params){
                let _color = that.color
                return _color[(params.dataIndex + 6) % 6] // 设置6种颜色，取下标余数，循环显示
              }
            },
            data: data.y
          }
        ],
      })
      $(window).resize(function () {
        myBarChart.resize()
      })
    },
    
    /**
     * 矩阵图
     */
    initTreemap: function(id, data){
      let that = this
      let myBarChart = this.echarts.init(document.getElementById(id))
      myBarChart.clear()
      myBarChart.setOption({
        tooltip: {
          padding: 0,
          backgroundColor: 'rgba(50,50,50,0)',
          borderColor: 'rgba(50,50,50,0)',
          borderWidth: 0,
          formatter: function (obj) {
            return '<div style="padding:10px; min-width:200px; border-radius: 20px; background-color: rgba(50,50,50,0.8);">'
              + '<h2 style="font-size:16px; font-weight:normal; padding-bottom:10px; text-align: left;">' + obj.data.name + '</h2>'
              + '<h3 style="font-size:12px; font-weight:normal; border-top:1px solid #ddd; line-height:36px;">' + that.tooltip1 + '<span style="float:right;">'+ that.millonFormat(obj.data.total) + ' ' + obj.data.unit + '</span></h3>'
              + '<h3 style="font-size:12px; font-weight:normal; border-top:1px solid #ddd; line-height:36px;">' + that.tooltip2 + '<span style="float:right;">'+ that.millonFormat(obj.data.growth_yoy) +'%</span></h3>'
              + '<h3 style="font-size:12px; font-weight:normal; border-top:1px solid #ddd; line-height:36px;">' + that.tooltip3 + '<span style="float:right;">'+ that.millonFormat(obj.data.growth) + ' ' + obj.data.unit + '</span></h3>'
              + '</div>'
              + '<div style="margin:auto; width: 0; height: 0; border-left: 20px solid transparent; border-right: 20px solid transparent; border-top: 20px solid rgba(50,50,50,0.8);"></div>'
          },
          position: function (point) {
            return [point[0] - 100, point[1] - 190]
          }
        },
        series: [
          {
            type: 'treemap',
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
            roam: false,
            nodeClick: false,
            breadcrumb: {
              show: false
            },
            label: {
              normal: {
                position: 'insideBottomLeft',
                formatter: function (params) {
                  let arr = ['{name|' + params.data.name + '}', '{percent|' + params.data.value + '%}']
                  return arr.join('\n')
                },
                rich: {
                  name: {
                    fontSize: 14,
                    lineHeight: 20,
                    color: '#FFFFFF'
                  },
                  percent: {
                    fontSize: 12,
                    lineHeight: 18,
                    color: '#FFFFFF'
                  },
                }
              }
            },
            data: data,
            itemStyle: {
              gapWidth: 1,
              borderColor: 'rgb(51,63,80)'
            }
          }
        ],
        color: that.color
      })
      $(window).resize(function () {
        myBarChart.resize()
      })
    },
  }
}
</script>